export enum GlobalClassesEnum {
  CommonContainer = 'commonContainer',
  // Texts
  CommonH1 = 'commonH1',
  CommonH1Bold = 'commonH1Bold',
  CommonH2 = 'commonH2',
  CommonH2Bold = 'commonH2Bold',
  CommonH3 = 'commonH3',
  CommonH3Bold = 'commonH3Bold',
  CommonH4 = 'commonH4',
  CommonH4Bold = 'commonH4Bold',
  CommonHeadline = 'commonHeadline',
  CommonHeadlineBold = 'commonHeadlineBold',
  CommonBody1Text = 'commonBody1Text',
  CommonBody1TextBold = 'commonBody1TextBold',
  CommonBody2Text = 'commonBody2Text',
  CommonBody2TextBold = 'commonBody2TextBold',
  CommonCaption = 'commonCaption',
  CommonCaptionBold = 'commonCaptionBold',
  CommonTextSecondary = 'commonTextSecondary',
  CommonDiscoverTitle = 'commonDiscoverTitle',
}
